module.exports = __webpack_public_path__ + "img/print.5d467c2a.svg";